class ExtendSectionS1 extends ExtendSectionBase {
  constructor() {
    super();
  }

  init() {
    this._listenSectionLoad();
    const _safeInit = (fn) => {
      try {
        return fn();
      } catch (e) {
        console.warn(`[ExtendSectionS1V3] ${fn.name} 初始化失败:`, e);
        return null;
      }
    };
    _safeInit(() => this.initS1Box());
    _safeInit(() => this.initS1UsageScenarioCards());
    _safeInit(() => this.initS1Testimonials());
    _safeInit(() => this.initS1Introduction03Cards());
    _safeInit(() => this.initS1Introduction05Cards());
    _safeInit(() => this.initS1DetailsCards());
  }

  initS1Box() {
    const $wrapperList = $('[name="extend-s1-box"]');
    if (!$wrapperList.length) return;
    this._registerSectionLoad("extend_s1_box", "extend-s1-box", "initS1Box");
    this._clearFlktyList("s1BoxTabsFlktyList");
    this._flktyListObj.s1BoxTabsFlktyList = [];
    $wrapperList.each((index, element) => {
      let activeIndex = 0;
      const $tabs = $(element).find('[name="extend-s1-box-tabs"]');
      const $cards = $(element).find('[name="extend-s1-box-cards"]');
      const $tabItems = $tabs.find(".es1b-tabs-item");
      const flktyTabs = new Flickity($tabs.get(0), {
        cellAlign: "left",
        contain: true,
        groupCells: false,
        pageDots: false,
        initialIndex: activeIndex,
        prevNextButtons: false,
        draggable: false,
      });
      this._syncFlktyWidth({
        flktyInstance: flktyTabs,
        maxWidth: window.innerWidth * 0.9,
      });
      __showCards($tabItems.eq(activeIndex).attr("card-type"), $cards);
      flktyTabs.on("select", () => {
        if (flktyTabs.selectedIndex === activeIndex) return;
        activeIndex = flktyTabs.selectedIndex;
      });
      flktyTabs.on("staticClick", (event, pointer, cellElement, cellIndex) => {
        if (cellIndex === activeIndex) return;
        flktyTabs.select(cellIndex);
        __showCards($tabItems.eq(activeIndex).attr("card-type"), $cards);
      });
      this._flktyListObj.s1BoxTabsFlktyList.push(flktyTabs);
    });

    function __showCards(type, $cards) {
      if (!type) return;
      const nowType = `is${type}`;
      $cards.find(".es1b-card").each(function (index, element) {
        $(element).attr(nowType) == "true"
          ? $(element).addClass("es1b-card--show")
          : $(element).removeClass("es1b-card--show");
      });
    }
  }

  initS1UsageScenarioCards() {
    const $cards = $('[name="extend-s1-usage-scenario-cards-mobile"]');
    if (!$cards.length) return;
    this._registerSectionLoad(
      "extend_s1_usage_scenario_cards",
      "extend-s1-usage-scenario",
      "initS1UsageScenarioCards"
    );
    this._clearFlktyList("s1UsageScenarioCardsFlktyList");
    this._flktyListObj.s1UsageScenarioCardsFlktyList = [];
    $cards.each((index, element) => {
      const flkty = new Flickity(element, {
        cellAlign: "left",
        prevNextButtons: false,
        pageDots: false,
      });
      flkty.on("resize", () => this._syncFlktyHeight($cards, flkty));
      flkty.resize();
      this._flktyListObj.s1UsageScenarioCardsFlktyList.push(flkty);
    });
  }

  initS1Testimonials() {
    const $testimonials = $('[name="extend-s1-testimonials"]');
    if (!$testimonials.length) return;
    this._registerSectionLoad(
      "extend_s1_testimonials",
      "extend-s1-testimonials",
      "initS1Testimonials"
    );
    const $testimonials_mobile = $('[name="extend-s1-testimonials-mobile"]');
    this._clearFlktyList("s1TestimonialsFlktyList");
    this._flktyListObj.s1TestimonialsFlktyList = [];
    $testimonials.each((index, element) => {
      const $videos = $(element).find('[name="extend-s1-testimonials-videos"]');
      const flkty = new Flickity($videos.get(0), {
        cellAlign: "left",
        contain: true,
        groupCells: true,
        pageDots: false,
        prevNextButtons: true,
      });
      this._flktyListObj.s1TestimonialsFlktyList.push(flkty);
    });
    $testimonials_mobile.each((index, element) => {
      const $videos = $(element).find('[name="extend-s1-testimonials-videos"]');
      const flkty = new Flickity($videos.get(0), {
        cellAlign: "left",
        autoPlay: false,
        pauseAutoPlayOnHover: false,
        prevNextButtons: false,
        pageDots: false,
      });
      this._flktyListObj.s1TestimonialsFlktyList.push(flkty);
    });
  }

  initS1Introduction03Cards() {
    const $wrapperList = $('[name="extend-s1-introduction03"]');
    if (!$wrapperList.length) return;
    this._registerSectionLoad(
      "extend_s1_introduction03_cards",
      "extend-s1-introduction03",
      "initS1Introduction03Cards"
    );
    this._clearFlktyList("s1Introduction03FlktyList");
    this._flktyListObj.s1Introduction03FlktyList = [];
    $wrapperList.each((index, element) => {
      let activeIndex = 0;
      const $cards = $(element).find('[name="extend-s1-introduction03-cards"]');
      const $tabs = $(element).find('[name="extend-s1-introduction03-tabs"]');
      const flktyCards = new Flickity($cards.get(0), {
        cellAlign: "center",
        contain: false,
        pageDots: false,
        initialIndex: activeIndex,
        prevNextButtons: false,
      });
      const flktyTabs = new Flickity($tabs.get(0), {
        cellAlign: "left",
        contain: true,
        pageDots: false,
        initialIndex: activeIndex,
        prevNextButtons: false,
        draggable: false,
      });
      this._syncFlktyWidth({
        flktyInstance: flktyTabs,
        maxWidth: window.innerWidth * 0.9,
      });
      flktyCards.on("select", () => {
        if (flktyCards.selectedIndex === activeIndex) return;
        activeIndex = flktyCards.selectedIndex;
        flktyTabs.select(activeIndex);
      });
      flktyTabs.on("select", () => {
        if (flktyTabs.selectedIndex === activeIndex) return;
        activeIndex = flktyTabs.selectedIndex;
        flktyCards.select(activeIndex);
      });
      flktyTabs.on("staticClick", (event, pointer, cellElement, cellIndex) => {
        if (cellIndex === activeIndex) return;
        flktyCards.select(cellIndex);
        flktyTabs.select(cellIndex);
      });
      this._flktyListObj.s1Introduction03FlktyList.push(flktyCards, flktyTabs);
    });
  }

  initS1Introduction05Cards() {
    const $wrapperList = $('[name="extend-s1-introduction05"]');
    if (!$wrapperList.length) return;
    this._registerSectionLoad(
      "extend_s1_introduction05_cards",
      "extend-s1-introduction05",
      "initS1Introduction05Cards"
    );
    this._clearFlktyList("s1Introduction05FlktyList");
    this._flktyListObj.s1Introduction05FlktyList = [];
    $wrapperList.each((index, element) => {
      let activeIndex = 0;
      const $cards = $(element).find('[name="extend-s1-introduction05-cards"]');
      const $tabs = $(element).find('[name="extend-s1-introduction05-tabs"]');
      const flktyCards = new Flickity($cards.get(0), {
        cellAlign: "left",
        contain: true,
        pageDots: false,
        initialIndex: activeIndex,
        prevNextButtons: false,
      });
      const flktyTabs = new Flickity($tabs.get(0), {
        cellAlign: "left",
        contain: true,
        pageDots: false,
        initialIndex: activeIndex,
        prevNextButtons: false,
        draggable: false,
      });
      this._syncFlktyWidth({
        flktyInstance: flktyTabs,
        maxWidth: window.innerWidth * 0.9,
      });
      flktyCards.on("select", () => {
        if (flktyCards.selectedIndex === activeIndex) return;
        activeIndex = flktyCards.selectedIndex;
        flktyTabs.select(activeIndex);
      });
      flktyTabs.on("select", () => {
        if (flktyTabs.selectedIndex === activeIndex) return;
        activeIndex = flktyTabs.selectedIndex;
        flktyCards.select(activeIndex);
      });
      flktyTabs.on("staticClick", (event, pointer, cellElement, cellIndex) => {
        if (cellIndex === activeIndex) return;
        flktyCards.select(cellIndex);
        flktyTabs.select(cellIndex);
      });
      this._flktyListObj.s1Introduction05FlktyList.push(flktyCards, flktyTabs);
    });
  }

  initS1DetailsCards() {
    const $cards = $('[name="extend-s1-details-cards"]');
    if (!$cards.length) return;
    this._registerSectionLoad(
      "extend_s1_details_cards",
      "extend-s1-details",
      "initS1DetailsCards"
    );
    this._clearFlktyList("s1DetailsCardsFlktyList");
    this._flktyListObj.s1DetailsCardsFlktyList = [];
    $cards.each((index, element) => {
      const flkty = new Flickity(element, {
        setGallerySize: true,
        cellAlign: "center",
        contain: true,
        prevNextButtons: false,
        pageDots: false,
      });
      flkty.on("resize", () => this._syncFlktyHeight($cards, flkty));
      flkty.resize();
      this._flktyListObj.s1DetailsCardsFlktyList.push(flkty);
    });
  }
}
